import { IPageMetadata, SSRResult } from '../src/interfaces/nextjs';
import { EmailError, IEmailErrorProps } from '../src/views/EmailError/EmailError';
import { GlobalLayout } from '../src/components/Layouts/GlobalLayout';
import { AppLogic } from '../src/components/AppLogic/AppLogic';
import { GetServerSidePropsContext } from 'next';

export async function getServerSideProps({
  query,
}: GetServerSidePropsContext): SSRResult<IPageMetadata & IEmailErrorProps> {
  const src = query.src as string;
  return {
    props: {
      _page: 'email_error',
      _pageTitle: 'Error',
      errorSource: src,
    },
  };
}

EmailError.getLayout = function getLayout(page: any) {
  return (
    <AppLogic pageProps={page.props}>
      <GlobalLayout hideStickyBannerGetApp>{page}</GlobalLayout>
    </AppLogic>
  );
};

export default EmailError;
